import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Requester } from "../_";
import { GlobalSettingContext } from "../GlobalSetting";
import { SuperProTableEnhancer } from "../SuperProTable";
import { HappyProvider } from '@ant-design/happy-work-theme';
import { ApolloProvider } from '@apollo/client';
import { useLocalStorageState } from 'ahooks';
import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { SuperRootContainerAlerter } from "./Alerter";
export var SuperRootContainer = function SuperRootContainer(properties) {
  var _userSetting$superRoo;
  var _useLocalStorageState = useLocalStorageState("JiShuXin['GlobalSetting']", {
      defaultValue: {},
      listenStorageChange: true
    }),
    _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 2),
    rawUserSetting = _useLocalStorageState2[0],
    setRawUserSetting = _useLocalStorageState2[1];
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    userSetting = _useState2[0],
    setUserSetting = _useState2[1];
  useEffect(function () {
    setUserSetting(Object.entries(rawUserSetting).reduce(function (previousValue, currentValue) {
      return _.set(previousValue, currentValue[0], currentValue[1]);
    }, {}));
  }, [rawUserSetting]);
  useEffect(function () {
    var _userSetting$_;
    if ((_userSetting$_ = userSetting._) !== null && _userSetting$_ !== void 0 && _userSetting$_.timeZone) {
      dayjs.prototype.format = new Proxy(dayjs.prototype.format, {
        apply: function apply(target, thisArg, argArray) {
          var _userSetting$_2;
          return Reflect.apply(target, thisArg.tz((_userSetting$_2 = userSetting._) === null || _userSetting$_2 === void 0 ? void 0 : _userSetting$_2.timeZone), argArray);
        }
      });
    }
  }, [userSetting]);
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: Requester.instance
  }, /*#__PURE__*/React.createElement(GlobalSettingContext.Provider, {
    value: [userSetting, setRawUserSetting]
  }, /*#__PURE__*/React.createElement(SuperProTableEnhancer, null, /*#__PURE__*/React.createElement(SuperRootContainerAlerter, null,
  // 判断是否需要启用快乐工作主题
  (_userSetting$superRoo = userSetting.superRootContainer) !== null && _userSetting$superRoo !== void 0 && _userSetting$superRoo.enableHappyWorkTheme ? /*#__PURE__*/React.createElement(HappyProvider, null, properties.children) : properties.children))));
};